let options = {
    scrollButtonClass: 'scroll-top'
};

const eventHandler = {
    scroll: () => {
        const scrollButtonReference = document.querySelector(`.${options.scrollButtonClass}`);
        if (window.pageYOffset - window.innerHeight >= 0) {
            scrollButtonReference.classList.add("show");
        } else {
            scrollButtonReference.classList.remove("show");
        }
    },
    click: () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }
};

const scrollTop = {
    init: (overwriteOptions) => {
        options = Object.assign(options, overwriteOptions);
        window.addEventListener("scroll", eventHandler.scroll);
        const scrollButtonReference = document.querySelector(`.${options.scrollButtonClass}`);
        scrollButtonReference.addEventListener('click', eventHandler.click);
    }
};

export {scrollTop}
